import { Text, Button } from 'wikr-core-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormEvent, useEffect, useState } from 'react';
import { useFormik } from 'formik';

import appConfig from 'appConfig';

import { PUBLIC } from 'router/routes';

import { sendTemporaryPassword } from 'store/auth/actions';

import { trackScreenLoad } from 'services/analytics/trackers/mainTrackers';
import { sendAnalyticLoginClick } from 'services/analytics';

import { useDispatch } from 'hooks/store';

import { isEmpty } from 'helpers/utils';

import FormikInput from 'components/FormikInput';
import AuthWrapper from 'components/AuthWrapper';

import * as S from './LoginContainer.styled';

import emailIcon from 'assets/img/icons/emailIcon.webp';

import { LoginSchema } from './validationSchema';

const LoginContainer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => trackScreenLoad(), []);

    const [isFetching, setFetchingStatus] = useState<boolean>(false);

    const {
        errors,
        dirty,
        values,
        initialValues,
        setFieldTouched,
        setFieldValue,
        touched,
        handleSubmit,
        setFieldError,
    } = useFormik({
        initialValues: { email: '' },
        validationSchema: LoginSchema,
        validateOnBlur: true,
        onSubmit: ({ email }: { email: string }) => {
            setFetchingStatus(true);
            dispatch(
                sendTemporaryPassword({
                    email,
                    onSuccess: handleSuccessLogin,
                    onError: handleLoginError,
                })
            );
        },
    });

    const onSubmitHandler = (event?: FormEvent<HTMLFormElement> | undefined) => {
        sendAnalyticLoginClick();

        handleSubmit(event);
    };
    const handleSuccessLogin = () => {
        setFetchingStatus(false);
        navigate(PUBLIC.ONE_TIME_PASSWORD.path);
    };

    const handleLoginError = () => {
        setFieldError('email', t('login.input.email.invalid'));
        setFetchingStatus(false);
    };

    return (
        <AuthWrapper>
            <S.LoginForm>
                <div>
                    <Text type="h5" bold center mb={12} text={t('login.title')} />
                    <Text center mb={4} text={t('login.subTitle')} />
                    <Text type="overline" bold center mb={16}>
                        <a href={appConfig.links.onboarding} data-locator="surveyButton">
                            {t('login.survey')}
                        </a>
                    </Text>

                    <S.LoginEmailInput>
                        <FormikInput
                            key="email"
                            type="email"
                            field="email"
                            label="input.email.label"
                            setFieldTouched={setFieldTouched}
                            initialValues={initialValues}
                            setFieldValue={setFieldValue}
                            touched={touched}
                            values={values}
                            errors={errors}
                            leftIcon={emailIcon}
                            dataLocator="emailInput"
                            placeholder="input.email.placeholder"
                        />
                    </S.LoginEmailInput>
                </div>

                <Button
                    onClick={onSubmitHandler}
                    disabled={!dirty || !isEmpty(errors) || isFetching}
                    text={t('basics.login')}
                    isLoading={isFetching}
                    dataLocator="loginButton"
                />
            </S.LoginForm>
        </AuthWrapper>
    );
};

export default LoginContainer;
